import type { ReactNode } from 'react';
import { SEARCH_HIGHLIGHT_CLASS_MESSENGER } from '@/utils/highlightSearchTerms';
import { linkifyPlainText } from '@/utils/linkifyPlainText';

type MessageTextWithMetaProps = {
  text: string;
  bodyClassName: string;
  meta: ReactNode;
  className?: string;
  /** Слова из поиска сайдбара мессенджера — подсветка в тексте пузыря */
  searchHighlightWords?: readonly string[];
};

export function MessageTextWithMeta({
  text,
  bodyClassName,
  meta,
  className,
  searchHighlightWords,
}: MessageTextWithMetaProps): ReactNode {
  const body = linkifyPlainText(text, {
    highlightWords: searchHighlightWords,
    highlightClassName: SEARCH_HIGHLIGHT_CLASS_MESSENGER,
  });
  return (
    <div className={['chatAssistant__dmTextWithMeta', className].filter(Boolean).join(' ')}>
      <div className={['chatAssistant__dmTextWithMetaBody', bodyClassName].filter(Boolean).join(' ')}>
        {body}
        <span className="chatAssistant__dmTextWithMetaMeta">{meta}</span>
      </div>
    </div>
  );
}
